import { LastActiveAppletMissed, UpdateActiveAppletBinary } from '@signageos/actions/dist/Applet/appletActions';
import { call, put, takeEvery } from 'redux-saga/effects';
import { bindAndTakeEvery } from '../../Socket/socketActionCreator';
import { GetSupraScreenConfig, UpdateSupraScreenConfig } from '@signageos/actions/dist/Supra/Screen/supraScreenActions';
import { injectDependencies } from '../../DI/dependencyInjection';
import { SUPRA_APPLET_UID } from './supraConstants';
import { AuthenticationSucceed } from '@signageos/actions/dist/Authentication/authenticationActions';
import { IPropertyStorage } from '../../Property/propertyStorage';
import { IServerSupraScreenConfig, IAppletSupraScreenConfig } from './supraConfig';
import Property from '../../Property/Property';
import isEqual from 'lodash/isEqual';
import { ReevaluateActiveAppletBinary } from '../AppletTiming/appletTimingActions';

export function* supraModeSagas(propertyStorage: IPropertyStorage) {
	// Initialize supraRuntimeState in DI container (null = "searching" until timing controller evaluates)
	yield call(injectDependencies, { supraRuntimeState: null });

	yield bindAndTakeEvery(AuthenticationSucceed, function* () {
		yield put({
			type: GetSupraScreenConfig,
		} satisfies GetSupraScreenConfig);
	});
	yield bindAndTakeEvery(UpdateSupraScreenConfig, function* (action: UpdateSupraScreenConfig) {
		const newConfig: IServerSupraScreenConfig = {
			servers: action.servers,
		};
		try {
			const oldConfig: IServerSupraScreenConfig | null = yield call(propertyStorage.getValueOrDefault, Property.SUPRA_SCREEN_CONFIG, null);
			yield call(propertyStorage.setValue, Property.SUPRA_SCREEN_CONFIG, newConfig);
			const configChanged = !isEqual(oldConfig, newConfig);
			const hasServers = action.servers.length > 0;
			if (configChanged && hasServers) {
				yield put({ type: ReevaluateActiveAppletBinary } satisfies ReevaluateActiveAppletBinary);
			}
		} catch (error) {
			console.error('Failed to evaluate supra config change', error);
			yield call(propertyStorage.setValue, Property.SUPRA_SCREEN_CONFIG, newConfig);
		}
	});
	yield takeEvery(UpdateActiveAppletBinary, function* (action: UpdateActiveAppletBinary) {
		if (action.activeAppletUid === SUPRA_APPLET_UID) {
			const config = action.activeConfiguration as Partial<IAppletSupraScreenConfig>;
			yield call(injectDependencies, {
				frontPowerActionsDisabled: true,
				supraRuntimeState: {
					isActive: true,
					connection: {
						hostname: config.hostname ?? '',
						secure: config.secure === 1,
						appName: config.appName,
						extraArgs: config.extraArgs,
						clientID: config.clientID,
						supraScreenAppletVersion: action.activeAppletVersion,
					},
				},
			});
		} else {
			yield call(injectDependencies, {
				frontPowerActionsDisabled: false,
				supraRuntimeState: { isActive: false },
			});
		}
	});
	yield takeEvery(LastActiveAppletMissed, function* () {
		yield call(injectDependencies, {
			frontPowerActionsDisabled: false,
			supraRuntimeState: { isActive: false },
		});
	});
}
